<template>
  <div class="product-page" id="product-page">
    <div v-if="holder" class="holder"></div>
    <div v-else class="container">
      <div class="desktop">
        <div v-if="product.categorys.length" class="breadcrumb bread-prod">
          <router-link class="breadcrumb__link" to="/">Home</router-link>
          <router-link class="breadcrumb__link" :to="`/produtos/${catUrl}`"
            >Produtos</router-link
          >
          <router-link class="breadcrumb__link" :to="`/produtos/${catUrl}`">
            {{ product.categorys[0].name }}
          </router-link>
          <span class="prod" to="/product">{{
            product.name | productName
          }}</span>
        </div>

        <div v-else class="breadcrumb bread-prod"></div>

        <div class="product-container">
          <div class="first-row">
            <div class="product-info">
              <div class="product-info__content">
                <h1 class="product-info__title">
                  {{ product.name | productName }}
                </h1>
                <span class="product-info__ref">Ref: {{ product.ref }}</span>
                <h2 class="product-info__desc">{{ product.title }}</h2>
                <h3 class="product-info__details-title">Detalhes</h3>
                <vue-markdown
                  :source="product.description"
                  class="product-info__details-text"
                ></vue-markdown>
                <span class="lancamento new-prod">lançamento</span>
                <h3 class="product-info__old-price" v-if="product.price">
                  De: {{ product.promotion | localePrice }}
                </h3>
                <h2 class="product-info__price" v-if="product.price">
                  {{ product.price | localePrice }}
                </h2>
              </div>
            </div>
            <div class="product-img">
              <div
                class="big-img"
                @click="openLightbox"
                v-if="product !== 'undefined'"
              >
                <lazy-image :image="product.images[imageOffset]"></lazy-image>
              </div>
              <div class="image-list">
                <div
                  v-for="(image, index) in product.images"
                  :key="'productimagelist' + image.id"
                  @click="imageOffset = index"
                  :class="{ active: imageOffset === index }"
                  class="image-list__item"
                >
                  <lazy-image :image="image"></lazy-image>
                </div>
              </div>
            </div>
          </div>
          <div v-if="product.categoria_option.length" class="option-container">
            <OptionCarousel
              v-for="(item, index) in product.categoria_option"
              :key="index + 'optioncarouselitem' + Math.random()"
              @sendOption="getOptions"
              :title="item.name"
              :options="item.options"
            />
          </div>
          <button class="send_btn prod-btn" @click="addProduct" type="submit">
            {{ product.price ? "Solicitar orçamento" : "Solicitar orçamento" }}
          </button>
        </div>
      </div>

      <div class="mobile">
        <div v-if="product.categorys.length" class="breadcrumb bread-prod">
          <router-link class="breadcrumb__link" to="/">Home</router-link>
          <router-link class="breadcrumb__link" :to="`/produtos/${catUrl}`"
            >Produtos</router-link
          >
          <router-link class="breadcrumb__link" :to="`/produtos/${catUrl}`">
            {{ product.categorys[0].name }}
          </router-link>
          <span class="prod" to="/product">{{
            product.name | productName
          }}</span>
        </div>

        <div v-else class="breadcrumb bread-prod"></div>

        <div class="product-container">
          <div class="first-row">
            <div class="product-info">
              <div class="product-info__content">
                <h2 class="product-info__title">
                  {{ product.name | productName }}
                </h2>
                <span class="product-info__ref">Ref: {{ product.ref }}</span>
                <!--                                <h3 class="product-info__desc">{{product.title}}</h3>-->
                <!--                                <vue-markdown :source="product.description"-->
                <!--                                              class="product-info__details-text"></vue-markdown>-->
                <span class="lancamento new-prod">lançamento</span>
              </div>
            </div>
            <div class="product-img">
              <div
                class="big-img"
                v-if="product !== 'undefined'"
                @click="openLightbox(imageOffset)"
                :style="{
                  backgroundImage: `url('${product.images[imageOffset].permalink}`,
                }"
              ></div>
              <div class="image-list">
                <div
                  v-for="(image, index) in product.images"
                  :key="index + 'product-image-page'"
                  @click="imageOffset = index"
                  :class="{ active: imageOffset === index }"
                  class="image-list__item"
                  :style="{ backgroundImage: `url('${image.permalink}` }"
                ></div>
              </div>
              <button
                class="send_btn prod-btn"
                @click="addProduct"
                type="submit"
              >
                {{
                  product.price ? "Solicitar orçamento" : "Solicitar orçamento"
                }}
              </button>
            </div>
          </div>
          <div v-if="product.categoria_option.length" class="option-container">
            <OptionCarousel
              v-for="(item, index) in product.categoria_option"
              :key="index + 'product-2-cat-option'"
              @sendOption="getOptions"
              :title="item.name"
              :options="item.options"
            />
            <h3 class="product-info__details-title">Detalhes</h3>
            <vue-markdown
              :source="product.description"
              class="product-info__details-text"
            ></vue-markdown>
          </div>
        </div>
      </div>
    </div>
    <Lightbox
      @closeLightbox="closeLightBox"
      :images="product.images"
      :single="false"
      :offset="imageOffset"
      :toggle="toggleLightbox"
    />
    <ModalConfirm :show="show" :msg="msg" />
    <TendenciesCarousel />
  </div>
</template>

<script>
import TendenciesCarousel from "../components/Shared/TendenciesCarousel";
import OptionCarousel from "../components/Product/OptionCarousel";
import ModalConfirm from "../components/Shared/ModalConfirm";
import VueMarkdown from "vue-markdown";
import Lightbox from "../components/Shared/Lightbox";
import LazyImage from "../components/Shared/LazyImage";

export default {
  name: "Product",
  props: ["id"],
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          property: "og:title",
          content: this.meta.title,
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: this.meta.description,
          vmid: "og:description",
        },
        {
          property: "og:image",
          content: this.meta.image,
          vmid: "og:image",
        },
        {
          property: "og:url",
          content: `https://fibrillare.com.br/${this.meta.url}`,
          vmid: "og:url",
        },
      ],
    };
  },
  data() {
    return {
      firstProduct: null,
      imageOffset: 0,
      holder: true,
      product: {},
      selectedOptions: {},
      options: null,
      msg: "",
      show: false,
      catUrl: "",
      toggleLightbox: false,
      meta: {
        title: "",
        description: "",
        image: "",
        url: "",
      },
    };
  },
  methods: {
    nextImage() {
      this.imageOffset--;
    },
    prevImage() {
      this.imageOffset++;
    },
    openLightbox() {
      this.toggleLightbox = true;
    },
    closeLightBox(val) {
      this.toggleLightbox = val;
    },
    getOptions(groupId, optId, img, name) {
      if (
        !("categoria_option" in this.product && "opcoesImg" in this.product)
      ) {
        this.product.opcoes = {};
        this.product.opcoesImg = {};
        this.product.opcoesName = {};
      }
      this.product.opcoes[groupId] = optId;
      this.product.opcoesName[groupId] = name;
      this.product.opcoesImg[groupId] = img;
    },
    addProduct() {
      if (this.$root.addProduct(this.product)) {
        this.msg = "Produto adicionado ao carrinho";
      } else {
        this.msg = "Produto já está no seu carrinho";
      }

      this.show = true;

      setTimeout(() => {
        this.show = false;
        this.$router.push("/quotelist");
      }, 1000);
    },
    fetchProduct() {
      axios.get(`/product/${this.$route.params.id}`).then((r) => {
        this.product = r.data;
        this.holder = false;
        this.meta.title = r.data.title;
        this.meta.description = r.data.meta_keywords;
        this.meta.image = r.data.images[0].permalink;
        this.meta.url = r.data.url;
        if (this.product.categorys.length) {
          axios.get(`/categories/${this.product.categorys[0].id}`).then((r) => {
            this.catUrl = r.data.url;
          });
        }
      });
    },
  },
  filters: {
    localePrice(val) {
      return val.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    productName(val) {
      return val.toLowerCase();
    },
  },
  mounted() {
    this.fetchProduct();
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  },
  components: {
    TendenciesCarousel,
    OptionCarousel,
    ModalConfirm,
    VueMarkdown,
    Lightbox,
    LazyImage,
  },
};
</script>

<style lang="scss" scoped>
#product-page {
  margin-top: 83px;
}

.mobile {
  display: none;
}

.prod {
  color: #666666;
  font-size: 0.875rem;
  font-family: "Poppins", Arial, sans-serif;

  &:first-letter {
    text-transform: uppercase;
  }
}

.bread-prod {
  max-width: 100%;
}

.new-prod {
  position: static;
}

.product-container {
  width: 100%;
  padding: 70px;
  border: 1px solid #e5e5e5;
}

.first-row {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.product-info {
  max-width: 500px;
  flex-shrink: 0;
  flex-grow: 1;

  &__content {
    position: relative;
  }

  &__title {
    font-family: "Open Sans", sans-serif;
    font-size: 2rem;
    color: #2b2b2b;
    margin-bottom: 5px;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  &__price,
  &__old-price {
    margin-top: 10px;
    font-family: "Open Sans", sans-serif;
    font-size: 2rem;
  }

  &__old-price {
    font-size: 1rem;
    text-decoration: line-through;
    color: #515151;
  }

  &__ref {
    color: #4d4d4d;
    font-size: 1rem;
    font-family: "Encode Sans", sans-serif;
  }

  &__desc {
    font-size: 1.5rem;
    font-family: "Open Sans", sans-serif;
    font-weight: 500;
    margin: 20px 0;
  }

  &__details-title {
    margin-bottom: 10px;
    font-family: Poppins, Arial, sans-serif;
    color: #2b2b2b;
    font-weight: 500;
  }

  &__details-text {
    white-space: pre-line;
    font-family: "Encode Sans", sans-serif;
    font-size: 0.875rem;
    color: #4d4d4d;
    margin-bottom: 25px;
  }
}

.product-img {
  /*max-width: 430px;*/
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-left: 40px;

  img {
    margin: 0 auto;
  }
}

.big-img {
  width: 100%;
  overflow: hidden;
  height: 380px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: 15px;
  cursor: pointer;
}

.image-list {
  display: flex;
  width: 100%;

  &__item {
    width: 70px;
    height: 70px;
    margin: 0 5px;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    border: 1px solid #e5e5e5;

    &:first-child {
      margin-right: 5px;
      margin-left: 0;
    }

    &:hover {
      opacity: 1;
    }

    &.active {
      opacity: 1;
    }
  }
}

.option-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.prod-btn {
  display: block;
  margin: 100px auto 0 auto;
}

@media only screen and(max-width: 1200px) {
  .product-container {
    padding: 20px;
  }

  .product-info {
    max-width: 420px;
  }
}

@media only screen and(max-width: 768px) {
  .first-row {
    flex-direction: column;
  }

  .option-container {
    justify-content: center;
  }
}

@media only screen and (max-width: 767px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .mobile .product-info__details-title {
    text-align: left;
    margin-top: 40px;
  }

  .mobile .prod-btn {
    margin-top: 20px;
  }

  .breadcrumb {
    max-width: 300px;
    flex-wrap: wrap;
  }

  .breadcrumb__link::after {
    margin-left: 20px;
  }

  .product-img {
    margin-left: 0;
  }

  .product-info__title {
    font-size: 1.5rem;
  }

  .big-img {
    margin-top: 30px;
    width: 260px;
    height: 180px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-bottom: 10px;
  }

  .image-list {
    margin-top: 10px;
    display: flex;

    &__item {
      width: 36px;
      height: 36px;
    }
  }

  .new-prod {
    margin-top: 15px;
    display: block;
  }
}
</style>
